import React, { CSSProperties, useState } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { Eye, EyeSlash, LockSimple } from 'phosphor-react';
import { FIELD_ADDON_WIDTH, FIELD_HEIGHT } from '../FieldGroup';
import { FIELD_ICON_SIZE } from '../fieldIcons';

interface PasswordInputFormProps extends InputProps {
  name: string | undefined | any;
  label: string | undefined;
  iconLeft?: JSX.Element | null;
  labelStyles?: CSSProperties;
  buttonStyles?: CSSProperties;
  isRequired?: boolean;
  register: UseFormRegister<FieldValues>;
  errors: any;
}

export const PasswordInputForm = ({
  name,
  label,
  iconLeft,
  labelStyles,
  buttonStyles,
  isRequired = false,
  register,
  errors,
  ...rest
}: PasswordInputFormProps) => {
  const [show, setShow] = useState(false);

  const handleClick = () => setShow((current) => !current);
  const resolvedIconLeft =
    iconLeft === null ? undefined : iconLeft ?? <LockSimple size={FIELD_ICON_SIZE} />;
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]}>
      <FormLabel style={labelStyles} htmlFor={name}>
        {label}
      </FormLabel>
      <InputGroup alignItems="center">
        {resolvedIconLeft && (
          <InputLeftElement
            pointerEvents="none"
            h={FIELD_HEIGHT}
            w={FIELD_ADDON_WIDTH}
            color="content.subtle"
          >
            {resolvedIconLeft}
          </InputLeftElement>
        )}
        <Input
          id={name}
          type={show ? 'text' : 'password'}
          pl={resolvedIconLeft ? FIELD_ADDON_WIDTH : undefined}
          pr={FIELD_HEIGHT}
          {...register(name)}
          {...rest}
        />
        <InputRightElement h={FIELD_HEIGHT} w={FIELD_HEIGHT}>
          <IconButton
            zIndex={1}
            type="button"
            size="xs"
            w="28px"
            h="28px"
            color="content.subtle"
            aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
            data-testid={`password-toggle-${name}`}
            style={buttonStyles}
            variant="ghost"
            onClick={handleClick}
          >
            {show ? <EyeSlash size={FIELD_ICON_SIZE} /> : <Eye size={FIELD_ICON_SIZE} />}
          </IconButton>
        </InputRightElement>
      </InputGroup>
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
